import React from 'react'

const LoadingData = ({t}) => {
  return (
    <div className="dashboard-loader">
      <h4 className="loading-text">
        {t("loading")}<span className="dots"></span>
      </h4>

      <p className="text-muted mt-2">
        {t("pleaseWaitWhileWeLoadTheData")}
      </p>
    </div>
  );
}

export default LoadingData